import styled from '@emotion/styled';
import Box, { BoxProps } from '@material-ui/core/Box';
import React from 'react';

const StyledWorkshopTileTag = styled(Box)`
  @media (max-width: 600px) {
    padding: 2px 5px 1.5px 4px;
  }
`;

const WorkshopTileTag = (props: BoxProps) => {
  const { children } = props;
  return (
    <StyledWorkshopTileTag
      borderRadius="5px"
      bgcolor="var(--blue-400)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="18px"
      {...props}
    >
      {children}
    </StyledWorkshopTileTag>
  );
};

export default WorkshopTileTag;
